"use client";
import Image from "next/image";
import { Stack, SimpleGrid, AspectRatio, Heading } from "@chakra-ui/react";
import { useSectionHeadingVariant } from "@/theme/components/useSectionHeading";
import { CUSTOMER_CONSTANTS, CUSTOMERS_LIST } from "./ourCustomers.constants";

const OurCustomers = () => {
  const HeadingVariant = useSectionHeadingVariant();
  return (
    <Stack spacing={10}>
      <Heading as="h2" variant={HeadingVariant} textAlign={"center"} px={2}>
        {CUSTOMER_CONSTANTS.TITLE}
      </Heading>
      <Stack borderRadius={"8px"} className="brand-shadow" spacing={8} py={10}>
        <SimpleGrid
          columns={{ base: 6, md: 8 }}
          columnGap={{ base: 3, sm: 4, md: 5 }}
          justifyContent={"center"}
          alignItems={"center"}
          rowGap={10}
          p={{ base: 3, md: 5 }}
        >
          {CUSTOMERS_LIST.map((customerImage, index) => {
            return (
              <AspectRatio ratio={2 / 1} key={index} position="relative" maxW="130px">
                <Image
                  src={customerImage}
                  alt={`Customer ${index + 1}`}
                  fill
                  style={{
                    objectFit: "contain",
                    objectPosition: "center",
                  }}
                />
              </AspectRatio>
            );
          })}
        </SimpleGrid>
      </Stack>
    </Stack>
  );
};

export default OurCustomers;
